import Reveal from '@/components/base/Reveal';
import { endings } from '@/mocks/comicData';

export default function Ending() {
  return (
    <section id="ending" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-8 px-4 md:grid-cols-2 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20glowing%20general%20store%20doorway%20at%20night%20seen%20from%20a%20rainy%20street%2C%20soft%20amber%20light%20spilling%20onto%20wet%20cobblestones%2C%20a%20figure%20standing%20under%20a%20paper%20umbrella%20looking%20back%2C%20gentle%20nostalgic%20mood%2C%20stylized%20painterly%20storybook%20illustration%20for%20a%20healing%20fantasy%20manga%2C%20warm%20orange%20and%20deep%20brown%20palette%2C%20emotional%20farewell%20atmosphere%2C%20high%20detail&width=1200&height=800&seq=ending-warm-scene&orientation=landscape"
              alt="雨夜中亮着暖光的杂货铺门口告别场景插画"
              className="h-full w-full object-cover object-center"
            />
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              结局解析
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug md:text-4xl">
              不是所有遗憾都要被填平，
              <br className="hidden md:block" />
              有些放下，本身就是圆满
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              《洞洞杂货铺漫画》的结局偏向温暖开放式。故事没有让每个人的愿望都如愿以偿，却让每个人都学会了与自己和解。以下几个关键点，决定了它为何被誉为「治愈系收尾的范本」。
            </p>

            <div className="mt-7 flex flex-col gap-4">
              {endings.map((e, i) => (
                <div key={e.title} className="flex gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold">{e.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-700">{e.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}